module.exports = __webpack_public_path__ + "img/6e90789.svg";